import {
  ADD_ROLE,
  EDIT_ROLE,
  GET_PERMISSION,
  GET_ROLE,
  GET_ROLE_PERMISSION,
} from "../types";

const initialState = {
  roleList: [],
  total: 20,
  permissionList: [],
  rolePermissionList: [],
};

export default function roleReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADD_ROLE:
      return {
        ...state,
        roleList: [payload, ...state.roleList],
      };

    case EDIT_ROLE:
      // editRole is dispatched with partial payloads (e.g. the status-toggle
      // action only sends { status, role_id }, no `name`) — only overwrite a
      // field when the payload actually included it, otherwise this blanks
      // out the row's name/other fields on every toggle.
      const updatedRoleList = state.roleList.map((role) => {
        if (role.id === payload.role_id) {
          return {
            ...role,
            ...(payload.name !== undefined ? { name: payload.name } : {}),
            status: payload.status === 1 || payload.status === "1" ? "active" : "inactive",
          };
        }
        return role;
      });

      return {
        ...state,
        roleList: updatedRoleList,
        rolePermissionList: [],
      };

    case GET_ROLE:
      return {
        ...state,
        roleList: payload?.data,
        total: payload?.total,
      };

    case GET_PERMISSION:
      return {
        ...state,
        permissionList: payload,
      };

    case GET_ROLE_PERMISSION:
      return {
        ...state,
        rolePermissionList: payload,
      };

    default:
      return state;
  }
}
